//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { LicenceCompanyVisibleDTO } from 'src/app/core/models/system/licence/licence-company-visible.dto';
import { Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class LicencesCompanyVisibleService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
    
  public delete(id: number): Observable<LicenceCompanyVisibleDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.delete(environment.eSimApi +
                                                                 eSimApiPaths.LicencesCompanyVisible +
                                                                 "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public getById(id: number): Observable<LicenceCompanyVisibleDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.LicencesCompanyVisible +
                                                                  "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getLicencesCompanyVisibleForHierarchy(companyId: number): Observable<LicenceCompanyVisibleDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<LicenceCompanyVisibleDTO[]>(environment.eSimApi +
                                                                                          eSimApiPaths.LicencesCompanyVisible + "/" +
                                                                                          eSimApiPaths.LicencesCompanyVisibleForHierarchy +
                                                                                          "?companyIdEncSS=" + companyIdEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getLicencesCompanyVisibleForSingleCompany(companyId: number): Observable<LicenceCompanyVisibleDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<LicenceCompanyVisibleDTO[]>(environment.eSimApi +
                                                                                          eSimApiPaths.LicencesCompanyVisible + "/" +
                                                                                          eSimApiPaths.LicencesCompanyVisibleForSingleCompany +
                                                                                          "?companyIdEncSS=" + companyIdEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public post(licenceCompanyVisible: LicenceCompanyVisibleDTO): Observable<LicenceCompanyVisibleDTO> {
    try {
      //JSON.stringify(licenceCompanyVisible)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(licenceCompanyVisible), true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.LicencesCompanyVisible +
                                                               "?objectEncSS=" + objectEncSS, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
      
  public put(licenceCompanyVisible: LicenceCompanyVisibleDTO): Observable<LicenceCompanyVisibleDTO> {
    try {
      //JSON.stringify(licenceCompanyVisible)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(licenceCompanyVisible), true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEncSS=encResult.result;
                            
                            return this.httpClientService.put(environment.eSimApi +
                                                              eSimApiPaths.LicencesCompanyVisible +
                                                              "?id=" + licenceCompanyVisible.id +
                                                              "&objectEncSS=" + objectEncSS, undefined, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
        
  public save(licenceCompanyVisible: LicenceCompanyVisibleDTO): Observable<LicenceCompanyVisibleDTO> {
    try {
      //JSON.stringify(licenceCompanyVisible);

      if (licenceCompanyVisible.id && <number>licenceCompanyVisible.id>0)
        return this.put(licenceCompanyVisible);
      
      return this.post(licenceCompanyVisible);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
